import React from 'react';
import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ExportToGoogleCalendarForm } from './ExportToGoogleCalendarForm';
import { useMutation } from 'urql';
import { MUTATION_UPDATE_EXPORTED } from 'queries/queries-booker';
import { SpinnerBlock } from 'components/SpinnerBlock';

export const CalsListing = observer(({ eventData }) => {
	const { calendarApi, notifications } = useStore();

	// updateExported mutation

	const [{ fetching }, executerUpdateExported] = useMutation(MUTATION_UPDATE_EXPORTED);

	// useEffect(() => {}, []);

	useEffect(() => {
		// console.log('update');

		if (calendarApi.gapiInited && calendarApi.gisInited && !calendarApi.calendars) {
			calendarApi.getCals();
		}

		return () => {
			// console.log('use effect end');
		};
	}, [calendarApi, calendarApi.gapiInited, calendarApi.gisInited]);

	// console.log('CAL API', calendarApi);

	const options =
		!calendarApi.isLoading &&
		!!calendarApi.calendars &&
		calendarApi.calendars.map((item: any) => {
			return { label: item.summary, value: item.id };
		});

	return (
		<>
			{calendarApi.isLoading && <SpinnerBlock />}

			{!calendarApi.isLoading && (
				<ExportToGoogleCalendarForm
					calendarOptions={options}
					calendarApi={calendarApi}
					isExporting={calendarApi.isExporing || fetching}
					onRefresh={calendarApi.getCals}
					onSubmit={(data) => {
						// console.log('ted exporting');
						// stavy notifikace
						// console.log('DATA', data);
						calendarApi.exportEvent(
							data.calendarId,
							eventData,
							data.exportPrices,
							() => {
								notifications.addNotification({ message: 'Exportováno' });
								// console.log('Exportovano');
								// console.log(eventData);

								executerUpdateExported({ id: eventData.id });
							},
							(err) => {
								//todo: what happend on error
							},
						);
					}}
				/>
			)}
		</>
	);
});
